import CameraDemo from './components/CameraDemo';

export default function App() {
  return <CameraDemo />;
}
